import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Owned by ui-components so that LibChartComponent can announce a completed
 * render without reaching into a consuming application. Page shells subscribe
 * to `rendered$` to react once the charts on the page have drawn.
 */
@Injectable({
  providedIn: 'root',
})
export class ChartRenderedService {

  private renderedSource = new Subject<boolean>();

  rendered$: Observable<boolean> = this.renderedSource.asObservable();

  rendered(): void {
    this.renderedSource.next(true);
  }
}
